'use client';
import styled from 'styled-components';

export const StyledCtaButton = styled.div`
  display: flex;
  justify-content: ${props => {
    switch (props.$alignment) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'center':
      default:
        return 'center';
    }
  }};

  & button {
    height: 56px;
  }
`;

export const CtaImageContainer = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  width: 20px;
  height: 20px;
  overflow: hidden;
  margin-right: ${props =>
    props.$position === 'left' ? props.theme.spacing(2) : '0'};
  margin-left: ${props =>
    props.$position === 'right' ? props.theme.spacing(2) : '0'};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
